import React from 'react';
import Icon from './Icon';
import { useAuth } from '../context/AuthContext';

const NAV_ITEMS = [
  { id: 'overview',    label: 'Executive Overview',  icon: 'overview' },
  { id: 'product',     label: 'Product Performance', icon: 'box' },
  { id: 'salesperson', label: 'Salesperson',         icon: 'people' },
];

const Sidebar = ({ active, onNav }) => {
  const { user, logout } = useAuth();

  const initials = user?.name
    ? user.name.split(' ').map((p) => p[0]).slice(0, 2).join('').toUpperCase()
    : (user?.avatar || '?');

  return (
    <aside className="sidebar">
      <div className="logo">
        <div className="logo-mark">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" strokeWidth="2.4"
               strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 20l5-14 4 9 4-9 5 14" />
          </svg>
        </div>
        <div className="logo-text">
          <b>AdventureWorks</b>
          <span>Cycles BI</span>
        </div>
      </div>

      <div className="nav-group-label">Workspace</div>
      {NAV_ITEMS.map((item) => (
        <div
          key={item.id}
          className={`nav-item ${active === item.id ? 'active' : ''}`}
          onClick={() => onNav(item.id)}
        >
          <span className="nav-icon"><Icon name={item.icon} size={15} /></span>
          {item.label}
          {item.badge && <span className="nav-badge">{item.badge}</span>}
        </div>
      ))}

      <div className="sidebar-user">
        <div className="avatar">{initials}</div>
        <div className="info">
          <b>{user?.name || 'Signed in'}</b>
          <span>{user?.role || ''}</span>
        </div>
        <button className="menu-btn" onClick={logout} title="Sign out">
          <Icon name="logout" size={14} />
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
